/**
 * External Dependencies
 */
//import 'jquery';
import "@lottiefiles/lottie-player";
import "select2";

(function($) {
  const hagesentreArr = [
    {
      "title": "Porsgrunn",
      "slug": "porsgrunn",
    },
    {
      "title": "Aurskog",
      "slug": "aurskog",
    },
    {
      "title": "Ørvik",
      "slug": "orvik",
    },
    {
      "title": "Leikvoll",
      "slug": "leikvoll",
    },
    {
      "title": "Bamble",
      "slug": "bamble",
    },
    {
      "title": "Grøa",
      "slug": "groa",
    },
    {
      "title": "Fredrikstad",
      "slug": "fredrikstad",
    },
    {
      "title": "Rød",
      "slug": "rod",
    },
    {
      "title": "Solblomsten",
      "slug": "solblomsten",
    },
    {
      "title": "Nathanielsen",
      "slug": "nathanielsen",
    },
    {
      "title": "Drøbak",
      "slug": "drobak",
    },
    {
      "title": "Kolsås",
      "slug": "kolsas",
    },
    {
      "title": "Kråkstad",
      "slug": "krakstad",
    },
    {
      "title": "Lillestrøm",
      "slug": "lillestrom",
    },
    {
      "title": "Arendal",
      "slug": "arendal",
    },
    {
      "title": "E-18",
      "slug": "e18",
    },
    {
      "title": "Garthe",
      "slug": "garthe",
    },
    {
      "title": "Fevik",
      "slug": "fevik",
    },
    {
      "title": "Dømmesmoen",
      "slug": "dommesmoen",
    },
    {
      "title": "Grimstad",
      "slug": "grimstad",
    },
    {
      "title": "Åssiden",
      "slug": "assiden",
    },
    {
      "title": "Foss",
      "slug": "foss",
    },
    {
      "title": "Hokksund",
      "slug": "hokksund",
    },
    {
      "title": "Hønefoss",
      "slug": "honefoss",
    },
    {
      "title": "Hvittingfoss",
      "slug": "hvittingfoss",
    },
    {
      "title": "Notodden",
      "slug": "notodden",
    },
    {
      "title": "Prestfoss",
      "slug": "prestfoss",
    },
    {
      "title": "Skoger",
      "slug": "skoger",
    },
    {
      "title": "Brumunddal",
      "slug": "brumunddal",
    },
    {
      "title": "Elverum",
      "slug": "elverum",
    },
    {
      "title": "Skarnes",
      "slug": "skarnes",
    },
    {
      "title": "Stange",
      "slug": "stange",
    },
    {
      "title": "Åsane",
      "slug": "asane",
    },
    {
      "title": "Askøy",
      "slug": "askoy",
    },
    {
      "title": "Eikanger",
      "slug": "eikanger",
    },
    {
      "title": "Fantoft",
      "slug": "fantoft",
    },
    {
      "title": "Fredheim",
      "slug": "fredheim",
    },
    {
      "title": "Fyllingsdalen",
      "slug": "fyllingsdalen",
    },
    {
      "title": "Kilden",
      "slug": "kilden",
    },
    {
      "title": "Knarvik",
      "slug": "knarvik",
    },
    {
      "title": "Litland",
      "slug": "litland",
    },
    {
      "title": "Midttun",
      "slug": "midttun",
    },
    {
      "title": "Sotra",
      "slug": "sotra",
    },
    {
      "title": "Stord",
      "slug": "stord",
    },
    {
      "title": "Vasstun",
      "slug": "vasstun",
    },
    {
      "title": "Voss",
      "slug": "voss",
    },
    {
      "title": "Eik",
      "slug": "eik",
    },
    {
      "title": "Slætta",
      "slug": "slaetta",
    },
    {
      "title": "Surnadal",
      "slug": "surnadal",
    },
    {
      "title": "Tilseth",
      "slug": "tilseth",
    },
    {
      "title": "Viddal",
      "slug": "viddal",
    },
    {
      "title": "Grythatten",
      "slug": "grythatten",
    },
    {
      "title": "Lønnum",
      "slug": "lonnum",
    },
    {
      "title": "Narvik",
      "slug": "narvik",
    },
    {
      "title": "Sandaa",
      "slug": "sandaa",
    },
    {
      "title": "Skogholt",
      "slug": "skogholt",
    },
    {
      "title": "Bjørke",
      "slug": "bjorke",
    },
    {
      "title": "Dokka",
      "slug": "dokka",
    },
    {
      "title": "Gausdal",
      "slug": "gausdal",
    },
    {
      "title": "Hadeland",
      "slug": "hadeland",
    },
    {
      "title": "Lillehammer",
      "slug": "lillehammer",
    },
    {
      "title": "Valdres",
      "slug": "valdres",
    },
    {
      "title": "Amundsen",
      "slug": "amundsen",
    },
    {
      "title": "Nordtvet",
      "slug": "nordtvet",
    },
    {
      "title": "Skajem",
      "slug": "skajem",
    },
    {
      "title": "Bygnes",
      "slug": "bygnes",
    },
    {
      "title": "Ebnes Ølen",
      "slug": "ebnes-olen",
    },
    {
      "title": "Edens Have",
      "slug": "edens-have",
    },
    {
      "title": "Egersund",
      "slug": "egersund",
    },
    {
      "title": "Karmsund",
      "slug": "karmsund",
    },
    {
      "title": "Klingsheim",
      "slug": "klingsheim",
    },
    {
      "title": "Raglamyr",
      "slug": "raglamyr",
    },
    {
      "title": "Strand",
      "slug": "strand",
    },
    {
      "title": "Tronsholen",
      "slug": "tronsholen",
    },
    {
      "title": "Vea",
      "slug": "vea",
    },
    {
      "title": "Dale",
      "slug": "dale",
    },
    {
      "title": "Florø",
      "slug": "floro",
    },
    {
      "title": "Leikanger",
      "slug": "leikanger",
    },
    {
      "title": "Sandane",
      "slug": "sandane",
    },
    {
      "title": "Åfjord",
      "slug": "afjord",
    },
    {
      "title": "Fosen",
      "slug": "fosen",
    },
    {
      "title": "Levanger",
      "slug": "levanger",
    },
    {
      "title": "Steinkjer",
      "slug": "steinkjer",
    },
    {
      "title": "Wormdal",
      "slug": "wormdal",
    },
    {
      "title": "Kvinesdal",
      "slug": "kvinesdal",
    },
    {
      "title": "Mandal",
      "slug": "mandal",
    },
    {
      "title": "Oddernes",
      "slug": "oddernes",
    },
    {
      "title": "Vågsbygd",
      "slug": "vagsbygd",
    },
    {
      "title": "Vennesla",
      "slug": "vennesla",
    },
    {
      "title": "Gjennestad",
      "slug": "gjennestad",
    },
    {
      "title": "Horten",
      "slug": "horten",
    },
    {
      "title": "Nøtterøy",
      "slug": "notteroy",
    },
    {
      "title": "Rom",
      "slug": "rom",
    },
    {
      "title": "Sande",
      "slug": "sande",
    },
    {
      "title": "Tjøme",
      "slug": "tjome",
    },
    {
      "title": "Vanse",
      "slug": "vanse",
    },
    {
      "title": "Lyngdal",
      "slug": "lyngdal",
    },
    {
      "title": "Gjøvik",
      "slug": "gjovik",
    },
    {
      "title": "Os",
      "slug": "os",
    },
    {
      "title": "Sandefjord",
      "slug": "sandefjord",
    },
    {
      "title": "Søgne",
      "slug": "sogne",
    },
  ];
	let clearspace = document.getElementById('toggleit');
  let togglefilter = document.getElementById('togglefilter');
  let togglegrid = document.getElementById('togglegrid');
  let mainmenu = document.getElementById('mainmenu');
  let intViewportHeight = window.innerHeight;
  let navigation = document.getElementById('primary');
  let navcover = document.getElementById('nav-cover');
  let closenav = document.getElementById('close');
  let hageasenterSVG = document.getElementById('hagesenter-logo');
  let hageasenterSomeImg = document.getElementById('hagesenter-somelogo');


  if (mainmenu) {
    mainmenu.addEventListener('click', function() {
    mainmenu.classList.toggle('is-active');
    navigation.classList.toggle('is-active');
    navcover.classList.toggle('hidden');

    if (mainmenu.classList.contains('is-active')) {
      mainmenu.setAttribute('aria-expanded', 'true');
    } else {
      mainmenu.setAttribute('aria-expanded', 'false');
    }
  });
  }

  if (closenav) {
    closenav.addEventListener('click', function() {
    mainmenu.classList.toggle('is-active');
    navigation.classList.toggle('is-active');
    navcover.classList.toggle('hidden');

    if (mainmenu.classList.contains('is-active')) {
      mainmenu.setAttribute('aria-expanded', 'true');
    } else {
      mainmenu.setAttribute('aria-expanded', 'false');
    }
  });
  }

  if (navcover) {
    navcover.addEventListener('click', function() {
    mainmenu.classList.toggle('is-active');
    navigation.classList.toggle('is-active');
    navcover.classList.toggle('hidden');

    if (mainmenu.classList.contains('is-active')) {
      mainmenu.setAttribute('aria-expanded', 'true');
    } else {
      mainmenu.setAttribute('aria-expanded', 'false');
    }
  });
  }

	// $ Works! You can test it with next line if you like
	console.log($);

  if (clearspace) {
    $(clearspace).on("click", function() {
      let clearspaceImage = $('.clearspaceimage');
      var src = (clearspaceImage.attr("src") === clearspaceImage.attr('data-togglesrc2')) ? clearspaceImage.attr('data-togglesrc1') : clearspaceImage.attr('data-togglesrc2');
      $(clearspaceImage).attr("src", src);
    });
  }

  if (togglefilter) {
    $(togglefilter).on("click", function() {
      let togglefilterImage = $('.togglefilterimage');
      var src = (togglefilterImage.attr("src") === togglefilterImage.attr('data-togglesrc2')) ? togglefilterImage.attr('data-togglesrc1') : togglefilterImage.attr('data-togglesrc2');
      $(togglefilterImage).attr("src", src);
    });
  }

  if (togglegrid) {
    $(togglegrid).on("click", function() {
      let togglegridImage = $('.togglegridimage');
      var src = (togglegridImage.attr("src") === togglegridImage.attr('data-togglesrc2')) ? togglegridImage.attr('data-togglesrc1') : togglegridImage.attr('data-togglesrc2');
      $(togglegridImage).attr("src", src);
    });
  }

  $(window).on("scroll", function() {
    if ($(this).scrollTop() > intViewportHeight) {
      $(mainmenu).fadeIn();
    }
  else {
     if ($(this).scrollTop() > intViewportHeight) {
      $(mainmenu).fadeIn();
     } else {
      $(mainmenu).fadeOut();
     }
  }

  });

  $('.has-dropdown').on("click", function(e) {
    e.preventDefault();
    $(this).find('.listtoggle').toggleClass('rotate-180');
    $(this).siblings('.submenu').toggleClass('hidden');
  });

  
  $.each(hagesentreArr, function (index, value) {
    $('#hagesentrene')
      .append($('<option class="hagesenteret" />')
        .val(value.slug)
        .text('Hageland '+value.title)
        .attr({
          'data-primaer': hagelandprofil.assetUrl +"images/hageland-logo-"+value.slug+".svg",
          'data-primaerurl' :  hagelandprofil.assetUrl +"downloads/hagesenter-logo-"+value.slug+".zip",
          'data-slug': value.slug,
        })
      );

      $('#somelogos')
      .append($('<option class="somelogo" />')
        .val(value.slug)
        .text('Hageland '+value.title)
        .attr({
          'data-primaer': hagelandprofil.assetUrl +"images/hageland-somelokal-"+value.slug+".png",
          'data-primaerurl' :  hagelandprofil.assetUrl +"downloads/hageland-somelokal-"+value.slug+".zip",
          'data-slug': value.slug,
        })
      );
  });


    $('#hagesentrene').select2({
      placeholder: 'Velg hagesenter',
      sorter: data => data.sort((a, b) => a.text.localeCompare(b.text)),
    });
    $('#hagesentrene').on('select2:select', function (e) {
      let primaer = $('#hagesentrene option:selected').attr('data-primaer');
      let downloadBtn = $('#hagesenterlogodownload');
      let downloadUrl = $('#hagesentrene option:selected').attr('data-primaerurl');
      let data = e.params.data;
      console.log(data);

      hageasenterSVG.src = primaer;
      $(downloadBtn).attr("href", downloadUrl);
      $(downloadBtn).text('Last ned for ' + data.text);
    });


    $('#somelogos').select2({
      placeholder: 'Velg hagesenter',
      sorter: data => data.sort((a, b) => a.text.localeCompare(b.text)),
    });
    $('#somelogos').on('select2:select', function (e) {
      let someprimaer = $('#somelogos option:selected').attr('data-primaer');
      let somedownloadBtn = $('#hagesentersomedownload');
      let somedownloadUrl = $('#somelogos option:selected').attr('data-primaerurl');
      let data = e.params.data;
      console.log(data);

      hageasenterSomeImg.src = someprimaer;
      $(somedownloadBtn).attr("href", somedownloadUrl);
      $(somedownloadBtn).text('Last ned for ' + data.text);
    });

	
})( jQuery );
